import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  ExternalSearchResult,
  QueryExternalSearchArgs,
} from '@tribeplatform/gql-client/types'
import { ExternalSearchResultFields } from '@tribeplatform/gql-client/types/generated'
import {
  useQuery,
  UseQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getSearchExternalKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QueryExternalSearchArgs
  fields?: ExternalSearchResultFields
  useQueryOptions?: UseQueryOptions<ExternalSearchResult[], ClientError>
}

export const useSearchExternal = ({
  variables,
  fields,
  useQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return {
    ...useQuery<ExternalSearchResult[], ClientError>(
      getSearchExternalKey({ variables, fields }),
      () => client.externalSearch(variables, fields),
      {
        ...useQueryOptions,
        enabled: !!variables?.query,
        refetchOnWindowFocus: false,
      },
    ),
  }
}
